export { withRouter as default } from 'react-router';


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-router-dom/es/withRouter.js
// module id = 1197
// module chunks = 0